export const ESTADO_NO_CREADO = 'NO_CREADO';

export function isProcesoNoCreado(row: { id?: number | null; estado?: string | null } | null | undefined): boolean {
  if (row == null) return false;
  return String(row.estado ?? '').toUpperCase() === ESTADO_NO_CREADO || row.id == null;
}

export function procesosRowId(row: {
  id?: number | null;
  workflowEmpresa?: { id?: number | null } | null;
  periodoActividadInstancia?: { id?: number | null } | null;
}): string {
  if (row.id != null) return String(row.id);
  return `no-creado-${row.workflowEmpresa?.id ?? 'x'}-${row.periodoActividadInstancia?.id ?? 'x'}`;
}

type NoCreadoPeriodosRow = {
  workflowEmpresa?: {
    empresa?: { id?: number | null } | null;
    workflow?: { id?: number | null; nombre?: string | null } | null;
  } | null;
  periodoActividadInstancia?: {
    periodo?: { id?: number | null } | null;
  } | null;
} | null | undefined;

export function procesosNoCreadoPeriodosSearch(row: NoCreadoPeriodosRow): string {
  const params = new URLSearchParams();
  params.set('page', '1');
  params.set('estado', ESTADO_NO_CREADO);
  const nombre = row?.workflowEmpresa?.workflow?.nombre?.trim();
  if (nombre) {
    params.set('workflowEmpresa.workflow.nombre', nombre);
  }
  const periodoId = row?.periodoActividadInstancia?.periodo?.id;
  if (periodoId != null) {
    params.set('periodoId', String(periodoId));
  }
  return params.toString();
}

export function parsePeriodoIdParam(search: string): number | null {
  const raw = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('periodoId');
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function filterInstanciasByPeriodoId<T extends { periodo?: { id?: number | null } | null }>(
  instancias: T[],
  periodoId: number | null | undefined,
): T[] {
  if (periodoId == null) return instancias;
  return instancias.filter(row => Number(row.periodo?.id) === periodoId);
}

export function procesosNoCreadoPeriodosPath(row: NoCreadoPeriodosRow): string | null {
  const empresaId = row?.workflowEmpresa?.empresa?.id;
  const workflowId = row?.workflowEmpresa?.workflow?.id;
  if (empresaId == null || workflowId == null) return null;
  const query = procesosNoCreadoPeriodosSearch(row);
  return `/procesos/empresas/${empresaId}/workflow/${workflowId}/periodos?${query}`;
}
